import { browser } from "$app/environment";
import { vuAudio } from "./vuAudio.svelte";

/**
 * Persists `{muted, volume}` in plain `localStorage`.
 *
 * VuTwin treats audio prefs the same way it treats the device identity:
 * a "soft secret / non-PII" value that lives on this device only. There
 * is no AES wrapper because none of the values are sensitive — anyone
 * with access to the device can already see the volume slider, and the
 * server never sees this data.
 */
const STORAGE_KEY = "vutwin.audio.prefs.v1";

interface AudioPrefs {
  muted: boolean;
  volume: number;
}

const DEFAULT: AudioPrefs = { muted: false, volume: 0.7 };

export function loadPrefs(): void {
  if (!browser) return;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    const parsed = JSON.parse(raw) as Partial<AudioPrefs>;
    vuAudio.applyPrefs({
      muted: parsed.muted ?? DEFAULT.muted,
      volume: parsed.volume ?? DEFAULT.volume,
    });
  } catch (err) {
    console.warn("[VuAudio] Failed to load prefs:", err);
  }
}

export function savePrefs(): void {
  if (!browser) return;
  try {
    const prefs: AudioPrefs = {
      muted: vuAudio.muted,
      volume: vuAudio.volume,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch (err) {
    console.warn("[VuAudio] Failed to save prefs:", err);
  }
}
